export default {
    downtimeUrl: "https://tr2.kodland.tech",
    startPage: {
      title:
        "<div>ÜCRETSİZ bir deneme dersi alın, kursunuzu seçin okulumuza kayıt yaptırın ve 1 yıllık ÜCRETSİZ programlama kursu çekilişine katılın!</div>",
      subtitle:
        "<div>O halde acele edin, bir yıllık TAM PROGRAMLAMA deneyimi sizi bekliyor! Eğer okulumuza kayıtlıysanız formu doldurmanıza gerek yoktur. Siz zaten bir katılımcısınız.</div>",
      button: "Katılın",
      image: {
        url:  "/welcome/quiz_turkey_one_year_gift_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_turkey_one_year_gift_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    successPage: {
      title: "Ücretsiz dersinizi almak için tarih belirleyin",
      subtitle: "📆 Hemen Kaydol butonuna tıklayarak rezervasyonu tamamlayabilirsiniz.",
      button: "📆 Hemen Kaydol",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title:
          "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
      },
    quizRotateBySteps: {
      1: {
        question:
          "Çocuğunuz gadget’larla günde ne kadar zaman harcıyor?",
        answers: [
            "😍 2 saat kadar", 
            "🙃 2-4 saat arası",
            "😔 4 saatten fazla",
            "🤔 Dikkat etmiyorum",
        ],
      },
      2: {
        question: "Çocuğunuzun kişisel özellikleri nedir?",
        answers: [
          "🏃🏻‍♂️ Aktif, çok iletişim kuran",
          "🥺 Utangaç, konuşmayı sevmiyor",
          "🤗 Hayalperest",
          "📚 Sessiz",
          "🤷‍♀️Ne istediğini bilmiyor",
          "✅ Diğer seçenek - Ücretsiz deneme dersinde anlayacağım",
        ],
      },
      3: {
        question: "Çocuğunuzun ilgi alanlarının neler olduğunu düşünüyorsunuz?",
        answers: [
          "🕸️ Web tasarımı",
          "🧑🏼‍🎨 Web Geliştirme",
          "🎮 Oyun yapmak",
          "🕹️ Roblox",
          "🎨 Grafik Tasarım",
          "👀 Diğer",
        ],
      },
      4: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true,
          },
        ],
      },
    },
  };
  